import { Enum } from "./Enum";

export const E_LOCATION = Object.freeze({
  MAIN: "/location",
  LOCATION_ID: (id: string = ":id") => `/location/${id}`,
});

export type E_LOCATION = Enum<typeof E_LOCATION>;
